import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Option } from "../../types/commonElements";
import { BranchState, FormData } from "../../types/branchType";

const initialState: BranchState = {
  formData: {
    name: "",
    email: "",
    phoneNumber: "",
    location: "",
    area: "",
    countryCode: {
      label: "+91",
      value: "+91",
    },
    country: {
      label: "India",
      value: 1,
    },
    state: "",
    city: "",
    pinCode: "",
  },
  errors: {},
  selectOptions: {
    country: [],
    city: [],
    phoneNumber: [],
    state: [],
  },
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setBranchFormData: (state, action: PayloadAction<Partial<FormData>>) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setBranchSelectOptions: (
      state,
      action: PayloadAction<{ [key: string]: Option[] }>
    ) => {
      state.selectOptions = action.payload;
    },
    setBranchErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearBranchErrors: (state) => {
      state.errors = {};
    },
    clearBranchForm: (state) => {
      state.formData = initialState.formData;
      state.selectOptions = {
        country: [],
        city: [],
        phoneNumber: [],
        state: [],
      };
      state.errors = {};
    },
  },
});

export const {
  setBranchFormData,
  setBranchErrors,
  clearBranchErrors,
  clearBranchForm,
  setBranchSelectOptions,
} = branchSlice.actions;

export default branchSlice.reducer;
